import { OffsetPreservingScrollView } from "./OffsetPreservingScrollView";

export function StylusIgnoringScrollView({
  children,
}: {
  children: React.ReactNode;
}) {
  return <OffsetPreservingScrollView>{children}</OffsetPreservingScrollView>;
}
